<template>
    <div class="tasas py-2" v-if="datos">
        <h6 class="text-center text-muted">{{ label }}</h6>
        <div class="col-12 col-md-12 d-flex justify-content-center">
            <div class="tasa" v-if="label !== 'Tasas comunas'">
                <p class="tasa__number">{{ tasaMortalidad }}</p>
                <p class="tasa__text">Tasa de mortalidad<br>por {{ tasa === 100000 ? '100 mil' : '1 millón de' }} habitantes</p>
            </div>
            <div class="tasa">
                <p class="tasa__number">{{ tasaContagio }}</p>
                <p class="tasa__text">Tasa de contagio<br>por {{ tasa === 100000 ? '100 mil' : '1 millón de' }} habitantes</p>
            </div>
        </div>
    </div>
</template>

<script>
import { formatNumber } from '../../charts'

export default {
    props: {
        label: {
            required: true,
            type: String
        },

        datos: {
            require: true,
            type: Object
        }
    },

    computed: {
        tasa () {
            if (this.label === 'Tasas regiones' || this.label === 'Tasas comunas' ) {
                return 100000
            }
            return 1000000
        },

        tasaMortalidad () {
            if (this.datos.habitantes) {
                const habitantes = this.datos.habitantes
                const datos = this.datos.data
                let fallecidos = 0 // Total de fallecidos a la fecha seleccionada
                for (var valor in datos) {
                    if (datos[valor].fallecidos) {
                        fallecidos = datos[valor].fallecidos
                        break;
                    }
                }
                if (fallecidos === 0) return 0
                return formatNumber((fallecidos / (habitantes / this.tasa)).toFixed(2))
            }
            return '-'
        },

        tasaContagio() {
            if (this.datos.habitantes) {
                const habitantes = this.datos.habitantes
                const datos = this.datos.data
                let contagios = 0
                for (var valor in datos) {
                    if (datos[valor].contagios) {
                        contagios = datos[valor].contagios
                        break;
                    }
                }

                if (contagios === 0) return 0
                return formatNumber((contagios / (habitantes / this.tasa)).toFixed(2))
            }
            return '-'
        },
    }
}
</script>

<style lang="scss">
.tasa {
  padding: 0.8rem;
  background-color: #fff;
  box-shadow: 0 2px 2px 0 rgba(0 ,0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);

  & + & {
    margin-left: 1rem;
  }
}

.tasa__number {
  text-align: center;
  margin-bottom: 0;
  font-size: 30px;
  font-weight: 700;
  color:#FFBA4E;
  &--dosis {
      font-size: 27px;
  }
}

.tasa__text {
  margin-bottom: 0;
  color: #000;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 9px;
  text-align: center;
}

</style>
